import * as React from "react"
import { HorizontalSpacer } from "../../atoms/spacers"
import { Container } from "react-grid-system"
import Card from "../../atoms/Card"
import Subtitle from "../../atoms/typography/Subtitle"
import BodyLarge from "../../atoms/typography/BodyLarge"
import H1 from "../../atoms/typography/H1"

const SalesTermsPage: React.FunctionComponent = () => {
  React.useEffect(() => {
    document.title = "General Sales Terms"
  }, [])

  return (
    <div>
      <HorizontalSpacer spacing={2} />
      <Container>
        <Card>
          <div style={{ padding: "2rem" }}>
            <HorizontalSpacer spacing={2} />
            <H1>General Sales Terms</H1>
            <HorizontalSpacer spacing={2} />

            <Subtitle>Preamble</Subtitle>
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                1. These General Sales Conditions <b>(the “Terms”)</b> shall apply to all sales made by Satcube and
                constitutes part of the Agreement between Satcube and Buyer. Deviations from the Terms shall not become
                binding unless agreed to in writing. When used in these Terms the term “written” or “in writing” refers
                to a document signed by both parties or, in the case of communication by one party, a letter or an
                e-mail.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Product and Technical Information</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                2. Data in product information, price lists and similar documents are binding only if expressly referred
                to by Satcube.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                3. All drawings, specifications and other technical documents relating to the products or the
                manufacturing thereof, including but not limited to software delivered or embedded in the products or
                designed for use in or together with the products
                <b>(the “Product Data”)</b>, shall remain the property of Satcube. Satcube grants the Buyer a
                non-exclusive, non-sublicenseable, non-transfer-able license to use the Product Data in connection with
                the intended use of the products. The Product Data may under no circumstances be used for any other
                purpose. No part of the Product Data may be copied, modified, reproduced, disassembled, transmitted or
                otherwise communicated to a third party. The Seller may terminate this license upon notice for violation
                of any of the terms of the license. The Buyer shall comply with all applicable laws and regulations in
                any country where performance of this Agreement will occur.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                4. Satcube shall on the Delivery Date (as defined below) provide one or the higher agreed number of the
                current user manual to the Buyer. Satcube is not obliged to supply any other documentation in relation
                to the products.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Delivery</Subtitle>
            <HorizontalSpacer spacing={1} />

            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                5. Unless otherwise agreed, the products shall be delivered DAP (Incoterms 2010) Satcube’s production
                facility in Sweden.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Time for Delivery. Delay</Subtitle>
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                6. Satcube may in the order confirmation make an estimate of the date when delivery can be made. Satcube
                does however not warrant that delivery will be made at a certain specified date or at the expiry of a
                certain period of time. Satcube will notify the Buyer of the exact delivery date in sufficient time
                prior thereto <b>(the “Delivery Date”)</b>.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>7. The risk for the products shall pass to the Buyer on the Delivery Date.</BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                8. If it becomes apparent that the Delivery Date will occur later than 12-14 weeks from the date of the
                order confirmation, Satcube shall without undue delay notify the Buyer thereof in writing, stating the
                reason therefor and if possible the time when delivery can be expected.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                9. If the Delivery Date has been prolonged with more than 120 days, for other reasons than as outlined
                in Clause 34 or for reasons attributable to the Buyer, then the Buyer may rescind the Agreement in
                respect of the products that are in delay.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                10. Other than the Buyer’s right of termination pursuant to Clause 9, all other claims in respect of a
                delay on the part of Satcube is hereby excluded.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                11. If the Buyer is unable to accept delivery of the products on the Delivery Date, or if delay on its
                part is likely to occur, the Buyer shall without undue delay notify Satcube thereof in writing, stating
                the reason for the delay and if possible the time when delivery can be accepted. Regardless of whether
                the Buyer can accept delivery on the Deliver Date or not, the Buyer is obliged to make full payment of
                the products when the products are ready for delivery pursuant to Clauses 5 and 6. If so requested by
                the Buyer, Satcube may take reasonable measures to arrange storage of the products and insure the
                products at the Buyer’s risk and expense.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                12. Unless the Buyer’s failure to accept delivery as referred to in Clause 11 is caused by a
                circumstance outlined in Clause 34, Satcube may rescind the Agreement in respect of the products which
                are ready for delivery but in respect of which delivery has not been accepted by the Buyer. If Satcube
                rescinds the Agreement, Satcube shall also be entitled to compensation for damages. Cancellation or
                rescheduling of the delivery by Buyer may be subject to additional charges by Seller.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Prices, Payment</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                13. Payment shall be made according to the Agreement.. All prices are exclusive of any VAT or additional
                taxes and charges. If no payment terms have been agreed, Satcube will invoice the full amount payable
                for the products when the order from Buyer has been confirmed by Satcube. No products will be shipped
                before full payment is received by Satcube.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                14. If the Buyer fails to pay for the products within 30 days of a demand by Satcube to pay any sum due,
                Satcube may rescind the Agreement in part or in its entirety through written notice to Buyer. If Satcube
                rescinds the Agreement, Satcube shall also be entitled to compensation for damages. Satcube also has the
                right to interest on any overdue payments in accordance with applicable law.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Retention of Title</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                15. The products shall remain the property of Satcube until paid for in full. Until title has passed to
                the Buyer, the Buyer undertakes to take good care of the products and not use or carry out modifications
                thereto without the prior written consent of Satcube.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Warranty for Defects</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                16. The products shall comply with the product description made available by Satcube to the Buyer{" "}
                <b>(the “Product Sheet”)</b>. Satcube shall, in accordance with the provisions of Clauses 16–25 below,
                rectify defects in the delivery which consists of products failing to meet the Product Sheet (in design,
                workmanship or material) and which arise within a period of twelve (12) months from the Delivery Date in
                case of new products and six (6) months from delivery for any repairs or replacements (each a
                <b>“Defect”)</b>.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                17. Satcube is not liable for defects arising out of material provided by the Buyer, a design
                stipulated, specified or requested by the Buyer, faults resulting from viruses or other external
                assaults or caused by third parties. Deviations from the Product Sheet which are insignificant for the
                intended use of the products and which do not inconvenience the Buyer, shall not constitute any
                liability on the part of Satcube. Furthermore, Satcube’s liability does not cover defects which arise
                after the risk of the products has passed to the Buyer (e.g. defects due to or accelerated by (i)
                conditions of operation deviating from those anticipated in the Agreement or otherwise recommended by
                Satcube, (ii) improper use of the products, (iii) faulty or poor maintenance, (iv) incorrect
                installation or handling of the products, (v) alterations, interference or modifications to the products
                made without Satcube’s prior written consent or (vi) faulty repairs not approved to by Satcube. For the
                avoidance of doubt, Satcube’s liability does not cover normal wear and tear or general deterioration.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                18. In order to be able to claim that the products are Defect, the Buyer must notify Satcube without
                undue delay after the Defect has appeared and in no case later than two (2) weeks after the expiry of
                the warranty period set out in Clause 16. Following the expiry of such period, Satcube shall have no
                liability for a Defect. If there is reason to believe that a Defect may cause damage, notice shall be
                given immediately. If notice is not so given, Satcube shall not be liable for any damage which could
                have been avoided if such notice had been timely given.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                19. Subject to the above, Satcube agrees to repair or replace, at its sole discretion, without charge,
                such products which are Defect and which are returned to Satcube’s appointed service point for repair or
                replacement. The Buyer shall bear all cost and the risk related to such transport. After receipt of the
                products, Satcube shall – if Satcube determines that the products are Defect – remedy or replace the
                Defect products s without undue delay.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                20. If the Buyer gives such notice as referred to in Clause 18, and no Defect is found for which Satcube
                is liable, Satcube shall be reimbursed for the work and costs incurred as a result of the Buyer’s
                notice.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                23. If a repair or replacement of a Defect requires intervention in other equipment, the Buyer shall be
                solely responsible for any work or costs caused by or incurred in connection therewith.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                24. Satcube shall be responsible for returning the products s to the place of original delivery.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>25. Defect products which have been replaced shall become the property of Satcube.</BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Indemnification</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                26. The Buyer shall indemnify and hold Satcube harmless against any loss, damage or cost arising out of
                or in connection with the Buyer’s use of the products and for which Satcube is not liable pursuant to
                this Agreement. The Buyer further assumes the entire responsibility and liability for, and agrees to
                indemnify and hold Satcube harmless from and against any and all losses, expenses, costs, damages
                (including consequential and incidental damages), demands, liabilities, suits and claims in connection
                with or arising out of any actual or alleged personal injury (including death) or damage or destruction
                to property (including loss of use) by whomsoever suffered, sustained or alleged to have been sustained
                by reason of (i) any act, error or omission, whether negligent or not, of Buyer or anyone for which the
                Buyer is responsible, provided that such injury, death, damage or destruction is not occasioned by the
                sole negligence of Seller or (ii) any failure of Buyer or anyone for which the Buyer is responsible to
                comply with any applicable law.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Intellectual Property Rights</Subtitle>
            <HorizontalSpacer spacing={1} />

            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                27. Satcube shall indemnify and hold the Buyer harmless against any loss, damage or cost arising out
                suits against Buyer for infringement by the products of any third party intellectual property rights,
                provided that the Buyer has used the products only in accordance with Satcube’s instructions or
                directions and:
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>a. notifies Satcube immediately in writing of any allegation of infringement;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. makes no admission of liability and does not agree to any settlement or compromise relating to the
                  alleged infringement; and
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. allows Satcube to conduct all negotiations and proceedings and give Satcube all reasonable
                  assistance in all such negotiations and proceedings relating to the alleged infringement.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>d. further legal action against you; and/or</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  e. disclosure of such information to law enforcement authorities as we reasonably consider to be
                  necessary or as otherwise required by law.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
              </div>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                28. The above notwithstanding, Satcube shall have no liability for any claim based upon or arising out
                of the (i) combination, operation, or use of any equipment or associated software in a manner for which
                it was not designed nor contemplated; or (ii) any modification of any equipment or associated software
                by the Buyer or any third party that causes the equipment or associated software to become infringing.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                29. Clauses 27 and 28 contain Satcube’s entire obligations with respect to any infringements of
                intellectual property rights.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Anti-Corruption and Export Control</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                30. The Buyer shall comply with applicable laws and regulations relating to anti-corruption, including
                without limitation, (i) the Swedish anti-corruption legislation; and (ii) the United States Foreign
                Corrupt Practices Act (FCPA).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                31. The Buyer acknowledges that the products may be subject to EU, US and other applicable sanctions and
                export and import control laws, rules and regulations (“Export Control Laws”), and the Buyer agrees to
                comply at all times with such Export Control Laws. Without limiting the foregoing, Buyer shall not,
                directly or indirectly, provide, sell or otherwise transfer any part of the products, Product Data or
                any direct product thereof in violation of applicable Export Control Laws. The Buyer is responsible for
                securing all necessary export control licenses and/or authorization for the products, as required.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                32. The Buyer shall notify Satcube if any deliverable under this Agreement is restricted by applicable
                Export Control Laws. The Buyer shall provide in writing to Satcube the export classification of any such
                item or controlled data and shall notify Satcube in writing of any changes to the export classification
                information of the item or controlled data.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                33. The Buyer shall be responsible for all losses, costs, claims, causes of action, damages, liabilities
                and expense, including attorneys' fees, all expense of litigation and/or settlement, and court costs,
                arising from any act or omission of the Buyer, its officers, employees, agents, suppliers, or
                subcontractors at any tier, in the performance of any of its obligations under Clauses 30-32.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Grounds for Relief (Force Majeure)</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                34. If a party is prevented from performing its obligations under this Agreement as a result of
                circumstances beyond its control, such as lightning, labor conflicts, fire, natural disaster, changes in
                applicable law, intervention by public authorities, inability to obtain material, labor, transport or
                manufacturing facilities, industrial disputes (embargoes, requisition, seizure, trade or currency
                restrictions), war, mobilization, insurrection and civil commotion, restrictions in the supply of power
                and defects or delays in deliveries by sub-contractors or sub-suppliers, such shall constitute force
                majeure and result in a postponement of the agreed time for performance and release from damages and any
                other sanctions. If performance of the Agreement is materially hindered for more than 6 months as a
                result of any circumstance stipulated above, either party shall be entitled to terminate the Agreement
                in writing without incurring any liability in damages.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                35. If grounds for relief pursuant to Clause 34 prevent the Buyer from fulfilling its obligations and
                the Buyer requires Satcube to secure and protect the products, then the Buyer shall be obliged to
                reimburse the expenses incurred by Satcube in so securing and protecting the products.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Limitation of Liability</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                36. Notwithstanding anything to the contrary set out herein, Satcube’s liability pursuant to this
                Agreement (including under Clauses 27-33) shall be limited to an amount corresponding to the lower of
                (a) 15 % of the annual total contract sum and (b) 200 000 USD. Satcube will only be liable for direct
                costs and will under no circumstances be liable for any indirect or consequential damages, including but
                not limited to loss of revenue, loss of profits, business or anticipated savings or any other indirect
                damage or loss of data. Furthermore, Satcube is never liable for the Buyer’s liability towards a third
                party. The limitation of liability set out in this Clause does not apply in the event of willful intent
                or gross negligence on the part of Satcube.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Confidentiality</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                37. The parties hereby undertake to maintain in absolute confidence any confidential information
                (including but not limited to the Product Data) disclosed by the other party in connection with this
                Agreement and not to disclose any such confidential information thus received to any third parties. The
                contents of this Agreement shall also be considered as confidential information.
              </BodyLarge>
            </div>

            <Subtitle>Disputes. Applicable Law</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                38. This Agreement shall be governed by Swedish law, without application of its conflict of law
                principles.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                39. Any dispute, controversy or claim arising out of or in connection with the Agreement shall be
                settled in general courts, with Stockholms tingsrätt as the first instance.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
          </div>
        </Card>
        <HorizontalSpacer spacing={2} />
      </Container>
    </div>
  )
}

export default SalesTermsPage
